// Module
var code = "<template> <require from=\"./grid-layout.scss\"></require> <div class=\"grid-layout-items\"> <slot> <div class=\"visibility-hidden\"></div> </slot> </div> </template> ";
// Exports
module.exports = code;